import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { trackEvent } from "@/utils/tagManagerUtils";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const GoogleAdsAutomatisierungDE = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackEvent("page_view", { path: "/de/google-ads-automatisierung" });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Google Ads Automatisierungstool | Upfixe</title>
        <meta
          name="description"
          content="Upfixe ist das ultimative Google Ads Automatisierungstool. Sparen Sie Stunden manueller Arbeit und lassen Sie die KI Ihre PPC-Kampagnen optimieren."
        />
        <meta
          name="keywords"
          content="google ads automatisierung, google ads tool, ki google ads, ppc optimierung"
        />
        <link rel="canonical" href="https://upfixe.com/de/google-ads-automatisierung" />
      </Helmet>

      <Header />

      <main className="flex-grow pt-24 pb-16">
        <section className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center mb-20">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 mb-6">
            Das intelligenteste <span className="text-primary">Google Ads Automatisierungstool</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-10">
            Hören Sie auf, Stunden mit manueller Keyword-Recherche und Gebotsanpassungen zu verschwenden.
            Upfixe automatisiert Ihren gesamten Google Ads-Workflow.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild size="lg" className="text-lg px-8 py-6 rounded-full">
              <a href="https://app.upfixe.com/signup">
                Kostenlos testen <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </Button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default GoogleAdsAutomatisierungDE;
